import { marker } from "@jsverse/transloco-keys-manager/marker";
import { toPairs } from "lodash-es";
import { sntTranslate } from "./translate";
import { Pet } from "../backend/models/pet/pet";

// const bloodTypes = () => {
//   A: sntTranslate(marker("A"));

// "DEA 1":sntTranslate(marker("A"));
//     "DEA 1-":sntTranslate(marker("A"));
//     "DEA 1+":sntTranslate(marker("A"));
//     "DEA 1.1":sntTranslate(marker("A"));
//     "DEA 1.1-":sntTranslate(marker("A"));
//     "DEA 1.1+":sntTranslate(marker("A"));
//     "DEA 1.2":sntTranslate(marker("A"));
//     "DEA 1.2-":sntTranslate(marker("A"));
//     "DEA 1.2+":sntTranslate(marker("A"));
//     "DEA 3":sntTranslate(marker("A"));
//     "DEA 4":sntTranslate(marker("A"));
//     "DEA 5":sntTranslate(marker("A"));
//     "DEA 6":sntTranslate(marker("A"));
//     "DEA 7":sntTranslate(marker("A"));
//     "DEA 8":sntTranslate(marker("A"));
// };

// export function getTypes() {
//   return toPairs(bloodTypes()).map(([key, value]) => ({
//     value: key,
//     display: value
//   }));
// }

export type SizePet =
  | "extra-small"
  | "small"
  | "medium"
  | "large"
  | "extra-large";

export function getSize(): Array<{
  display: string;
  value: SizePet;
}> {
  return [
    {
      value: "extra-small",
      display: sntTranslate(marker("Extra small"))
    },
    {
      value: "small",
      display: sntTranslate(marker("Small"))
    },
    {
      value: "medium",
      display: sntTranslate(marker("Medium"))
    },
    {
      value: "large",
      display: sntTranslate(marker("Large"))
    },
    {
      value: "extra-large",
      display: sntTranslate(marker("Extra large"))
    }
  ];
}

export type CoatType = "corto" | "lungo" | "riccio";
export type BloodTypeCat = "A" | "B" | "AB";
export type BloodTypeDog =
  | "DEA 1"
  | "DEA 1-"
  | "DEA 1+"
  | "DEA 1.1"
  | "DEA 1.1-"
  | "DEA 1.1+"
  | "DEA 1.2"
  | "DEA 1.2-"
  | "DEA 1.2+"
  | "DEA 3"
  | "DEA 4"
  | "DEA 5"
  | "DEA 6"
  | "DEA 7"
  | "DEA 8";

export function getbloodTypeCat(): Array<{
  display: string;
  value: BloodTypeCat;
}> {
  return [
    {
      value: "A",
      display: sntTranslate(marker("A"))
    },
    {
      value: "B",
      display: sntTranslate(marker("B"))
    },
    {
      value: "AB",
      display: sntTranslate(marker("AB"))
    }
  ];
}

export function getCoatType(): Array<{
  display: string;
  value: CoatType;
}> {
  return [
    {
      value: "corto",
      display: sntTranslate(marker("CORTO"))
    },
    {
      value: "lungo",
      display: sntTranslate(marker("LUNGO"))
    },
    {
      value: "riccio",
      display: sntTranslate(marker("RICCIO"))
    }
  ];
}

export function getbloodTypeDog(): Array<{
  display: string;
  value: BloodTypeDog;
}> {
  return [
    {
      value: "DEA 1",
      display: sntTranslate(marker("DEA 1"))
    },
    {
      value: "DEA 1+",
      display: sntTranslate(marker("DEA 1+"))
    },
    {
      value: "DEA 1-",
      display: sntTranslate(marker("DEA 1-"))
    },
    {
      value: "DEA 1.1",
      display: sntTranslate(marker("DEA 1.1"))
    },
    {
      value: "DEA 1.1+",
      display: sntTranslate(marker("DEA 1.1+"))
    },
    {
      value: "DEA 1.1-",
      display: sntTranslate(marker("DEA 1.1-"))
    },
    {
      value: "DEA 1.2",
      display: sntTranslate(marker("DEA 1.2"))
    },
    {
      value: "DEA 1.2+",
      display: sntTranslate(marker("DEA 1.2+"))
    },
    {
      value: "DEA 1.2-",
      display: sntTranslate(marker("DEA 1.2-"))
    },
    {
      value: "DEA 3",
      display: sntTranslate(marker("DEA 3"))
    },
    {
      value: "DEA 4",
      display: sntTranslate(marker("DEA 4"))
    },
    {
      value: "DEA 5",
      display: sntTranslate(marker("DEA 5"))
    },
    {
      value: "DEA 6",
      display: sntTranslate(marker("DEA 6"))
    },
    {
      value: "DEA 7",
      display: sntTranslate(marker("DEA 7"))
    },
    {
      value: "DEA 8",
      display: sntTranslate(marker("DEA 8"))
    }
  ];
}

export function getLastWeight(pet: Pet | Partial<Pet>): number {
  return pet.weighing && pet.weighing.length > 0
    ? pet.weighing?.reduce((currentWeightMore, currentWeight) => {
        return currentWeight.createdAt > currentWeightMore.createdAt
          ? currentWeight
          : currentWeightMore;
      }).weight
    : 0;
}
